<template>
  <div
    v-if="attributeValues.packaging && !giftVoucherIds.includes(product.id)"
    class="col-12 product-services packaging"
  >
    <div class="form-group">
      <label :for="`product-service-packaging-${attributeValues.packaging.id}`">
        {{ attributeValues.packaging.name }}
      </label>
    </div>
    <!-- designed for packaging -->
    <Packaging
      :service="attributeValues.packaging"
      :product="product"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import useProductService from './useProductService'
import Packaging from './Packaging'
import { giftVoucherIds } from '../../../../config'

export default {
  components: {
    Packaging,
  },
  props: {
    product: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      attributeValues: 'productService/getProductServices',
    }),
  },
  setup(props) {
    const { toggleService } = useProductService()

    return {
      toggleService,
      giftVoucherIds,
    }
  },
}
</script>
<style lang="scss">
.product-services {
  .form-group {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flexbox;
    display: flex;

    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    -moz-align-items: center;
    align-items: center;

    input[type="text"] {
      margin: 5px 0 10px 0 !important;
    }
  }

  .product-attributes {
    margin: 15px 0 0 0;
    justify-content: start;
  }
}
</style>
